/*
  Liga as imagens dos slides que nasceram adiadas (ec-deferred-image.liquid).

  Por que existe: num carrossel os slides seguintes ficam ao lado do primeiro, e
  o navegador trata isso como "perto da viewport" — baixa todos junto com o do
  LCP mesmo com loading="lazy". Medido no tema: 5 banners, 478 KB, todos na
  primeira carga, e o LCP no celular cai ~1s quando os 4 seguintes saem da frente.

  Quando hidrata, o que vier primeiro:
  - depois do load, no primeiro momento ocioso (é o caminho normal);
  - na hora, se a pessoa tocar, arrastar, rolar ou usar o teclado no carrossel;
  - na hora, no editor de tema, senão a pessoa edita um slide e vê um vazio.

  Sem JavaScript os slides seguintes ficam sem imagem. O primeiro, que é o que
  aparece e o que conta para o LCP, é normal e não passa por aqui.
*/
(function () {
  var SELETOR_FONTE = 'source[data-ec-slide-srcset]';
  var SELETOR_IMAGEM = 'img[data-ec-slide-src]';

  function hidratar(raiz) {
    var escopo = raiz || document;

    // As <source> primeiro: num <picture> a <img> escolhe a fonte na hora em que
    // o src é atribuído, então se a source ainda estiver vazia ele pega a errada.
    escopo.querySelectorAll(SELETOR_FONTE).forEach(function (fonte) {
      fonte.srcset = fonte.dataset.ecSlideSrcset;
      delete fonte.dataset.ecSlideSrcset;
    });

    escopo.querySelectorAll(SELETOR_IMAGEM).forEach(function (img) {
      if (img.dataset.ecSlideSrcset) {
        img.srcset = img.dataset.ecSlideSrcset;
        delete img.dataset.ecSlideSrcset;
      }
      img.src = img.dataset.ecSlideSrc;
      delete img.dataset.ecSlideSrc;
      img.classList.remove('ec-slide-deferred');
    });
  }

  function temPendente(raiz) {
    return !!(raiz || document).querySelector(SELETOR_IMAGEM + ',' + SELETOR_FONTE);
  }

  function agendar() {
    if (!temPendente()) return;
    if (window.requestIdleCallback) {
      window.requestIdleCallback(function () {
        hidratar();
      }, { timeout: 2500 });
    } else {
      setTimeout(hidratar, 800);
    }
  }

  // Interação com o carrossel não espera o ocioso: a pessoa quer ver o slide agora.
  var EVENTOS = ['pointerdown', 'touchstart', 'keydown', 'scroll', 'mouseover'];
  function ligarInteracao() {
    document.querySelectorAll('slideshow-component').forEach(function (carrossel) {
      EVENTOS.forEach(function (evento) {
        carrossel.addEventListener(
          evento,
          function () {
            hidratar();
          },
          { once: true, passive: true, capture: true }
        );
      });
    });
  }

  function iniciar() {
    ligarInteracao();
    if (document.readyState === 'complete') {
      agendar();
    } else {
      window.addEventListener('load', agendar, { once: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar, { once: true });
  } else {
    iniciar();
  }

  // No editor a seção é recriada a cada alteração: hidrata na hora, sem esperar.
  document.addEventListener('shopify:section:load', function (evento) {
    ligarInteracao();
    hidratar(evento.target);
  });
})();
